<shared-box [feel]="loading ? null : boxFeel" class="tile-for-loyalty-free-product{{boxFeel ? ' -feel-'+boxFeel : ''}}"
    [contentHorizontalPaddings]="true" [contentVerticalPaddings]="true"
    [ngClass]="{'-loaded': programItem && !programItem.isLoading}" (click)="handleClick($event)">

    <shared-header type="3" class="tile-for-loyalty-free-product__hd" [loading]="programItem?.isLoading || !programItem"
        marginTop="none" marginBottom="sm" [inverted]="titleInverted">
        {{programItem?.freeProduct?.length || 0}} Free {{programItem?.codeName}}
    </shared-header>

    <div class="tile-for-loyalty-free-product__desc">
        <ng-container *ngIf="programItem?.isLoading || !programItem">

            <shared-loader-for-placeholder class="tile-for-loyalty-free-product__loader -for-description">
            </shared-loader-for-placeholder>
            <shared-loader-for-placeholder class="tile-for-loyalty-free-product__loader -for-description">
            </shared-loader-for-placeholder>
        </ng-container>

        <ng-container *ngIf="programItem && !programItem.isLoading">
            Woo hoo you have a free {{programItem?.codeName}}.<br />
            Scan your card in store to redeem.
        </ng-container>
    </div>


</shared-box>
